/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import { connect } from 'react-redux'

import { getFileSystem } from 'app/state/modules/codeReview'

class FolderElement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: this.props.isOpen,
    }
    this.onClickFolder = this.onClickFolder.bind(this)
  }

  onClickFolder() {
    const { fileSystemKeys, item } = this.props
    if (!fileSystemKeys[item.path]) {
      this.props.getFileSystem(item.path, true)
    }
    const { isOpen } = this.state
    this.setState({
      isOpen: !isOpen,
    })
  }

  renderIcon() {
    if (this.state.isOpen) {
      return 'ri-folder-open-line'
    }
    return 'ri-folder-line'
  }

  render() {
    const { item } = this.props
    return (
      <li
        style={{ marginTop: 5 }}
        className={`uk-parent${this.state.isOpen ? ' uk-open' : ''}`}
        name={item.name}
      >
        <a
          onClick={this.onClickFolder}
          type="button"
          role="button"
          className={this.props.isActive ? 'uk-text-secondary' : ''}
        >
          <span
            style={{ fontSize: 18 }}
            className={`uk-margin-small-right ${this.renderIcon()}`}
          />
          {item.name}
        </a>
        {this.props.renderLevels()}
      </li>
    )
  }
}

const mapStateToProps = ({ codeReview }) => ({
  fileSystemKeys: codeReview.fileSystemKeys,
})

export default connect(mapStateToProps, {
  getFileSystem,
})(FolderElement)
